module.exports = __webpack_public_path__ + "img/itch.ca203014.png";